import React, { Component } from 'react';
import Slider from 'react-slick';
import FontAwesome from 'react-fontawesome'
import shared from '../../utils/shared.js'
import { connect } from 'react-redux';
import _ from 'lodash';

class Story extends Component {
    constructor(props) {
        super(props);
        this.refDict = {};
        this.goBack = this.goBack.bind(this);
        //      this.prepareBackButton = this.prepareBackButton.bind(this);
        this.goToSlide = this.goToSlide.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.lastSlide = this.lastSlide.bind(this);
        this.slideChanged = this.slideChanged.bind(this);
        //   this.activeModule = _.find(this.props.displayContent.dm_active, { id: this.props.displayData.selectedModuleId });
        //   this.lastModule = _.find(this.props.displayContent.dm_active, { id: this.props.displayData.prevModule });
        // if (!this.lastModule) {
        //     this.lastModule = this.activeModule;
        // }
        let index = 0;
        //console.log(this.props.options);
        if (this.props.options) {
            //console.log("had options", this.props.options);
            if (this.props.options.storyIndex) {
                index = this.props.options.storyIndex; //this should be 0
            }
        }

        this.state = {
            selectedImage: 0,
            index: index
        }
        this._validImages = [];
        for (var i=0; i<this.props.story.contents.images.length; i++){
            if (this.props.story.contents.images[i]){
                this._validImages.push(this.props.story.contents.images[i]);
            }
        }


    }

    componentWillMount(){
        shared.checkData(this.props.story);
    }

    componentDidMount() {

    }

    shouldComponentUpdate(prevProps, prevState) {
        if (shared.shallowEqual(this.state, prevState)) {
            return false;
        }
        return true;
    }

    // componentDidUpdate(prevProps, prevState) {
    //     // if (!this.props.displayData.selectedModuleId) { //data not yet recieved
    //     //     return null;
    //     // }
    //     if (this.props.displayData.selectedModuleId !== prevProps.displayData.selectedModuleId) { //data first recieved
    //         this.activeModule =  _.find(this.props.displayContent.dm_active, { id: this.props.displayData.selectedModuleId });
    //         this.lastModule = _.find(this.props.displayContent.dm_active, { id: this.props.displayData.prevModule });
    //         if (!this.state.story.id){
    //             this.populateStory();
    //         }
    //     }
    // }

    goBack(goRoute, e) {
        //browserHistory.push(goRoute);
    }

    goToSlide(slide) {
        this.refDict[0].slickGoTo(slide)
    }

    nextSlide() {
        this.refDict[0].slickNext()
    }

    lastSlide() {
        this.refDict[0].slickPrev()
    }


    prepareCycleButtons(blockWidth) {
        let bdist = this.props.screen.r16_9.p10 * 0.75;
        let halflength = ((this._validImages.length * bdist) / 2);
        let leftStart = (blockWidth / 2) - halflength + this.props.screen.screenHeight * .0185;
        let iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' }
        let iconStyleActive = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .75' }
        let spanclass = "fadediv"
        if (this.props.screen.idle === true) {
            spanclass += " fadeout"
        }

        return (
            this._validImages.map(function (row, i) {
                let iStyle = iconStyle;
                if (i === this.state.selectedImage) {
                    iStyle = iconStyleActive;
                }
                if (i === 0) {
                    return (
                        <span className={spanclass} key={i}>
                            <span onMouseDown={() => this.lastSlide()} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (-1 * bdist) }}>
                                <span className="phand" style={iconStyle}><FontAwesome name='arrow-circle-left' /></span>
                            </span>
                            <span onMouseDown={() => this.goToSlide(i)} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (i * bdist) }}>
                                <span className="phand" style={iStyle}><FontAwesome name='circle' /></span>
                            </span>
                        </span>
                    )
                }
                else if (i === this._validImages.length - 1) {
                    return (
                        <span className={spanclass} key={i}>
                            <span onMouseDown={() => this.goToSlide(i)} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (i * bdist) }}>
                                <span className="phand" style={iStyle}><FontAwesome name='circle' /></span>
                            </span>
                            <span onMouseDown={() => this.nextSlide()} style={{ textAlign: 'center', position: 'absolute', left: leftStart + ((i + 1) * bdist) }}>
                                <span className="phand" style={iconStyle}><FontAwesome name='arrow-circle-right' /></span>
                            </span>
                        </span>
                    )
                }
                else {
                    return (
                        <span className={spanclass} onMouseDown={() => this.goToSlide(i)} key={i} style={{ textAlign: 'center', position: 'absolute', left: leftStart + (i * bdist) }}>
                            <span className="phand" style={iStyle}><FontAwesome name='circle' /></span>
                        </span>
                    )
                }
            }, this)
        )
    }

    prepareModules(width) {
        var tileStyle = { textAlign: 'center' };
        var innerTile = { margin: '0 auto', textAlign: 'center', width: width, height: width, backgroundColor: 'white' };
        //console.log("images length here: ", this.props.story.contents.images.length);
        if (this._validImages.length<1){
            return (
                <div />
            )
        }

        if (this._validImages.length===0){
            return (
                <div style={tileStyle}>
                    <div style={innerTile}>
                        
                    </div>
                </div>
            )
        }

        return (
            this._validImages.map(function (row, i) {
                return (
                    <div key={i} style={tileStyle}>
                        <div style={innerTile}>
                            <img alt="Story" onMouseDown={this.preventDrag} className="nodrag" style={innerTile} src={shared.dpath(this.props.screen.mode, this._validImages[i].path, this._validImages[i].file_name, this.props.screen.webkey)} />
                        </div>
                    </div>
                )
            }, this)
        )
    }

    preventDrag(e) {
        if (e.preventDefault) e.preventDefault()
    }

    prepareBackButton() { //60, 60

        if (!this.lastModule) {
            return <span />
        }

        let goRoute = false;
        switch (this.lastModule.display_module_type) {
            case "Stories":
                //goRoute = "/stories?id=" + this.props.displayData.prevModule;
                break;
            default:
                break;
        }

        if (goRoute !== false) {
            return (
                <div className="phand" style={{ width: this.props.screen.r16_9.p10, height: this.props.screen.r16_9.p10 }} onClick={(e) => this.goBack(goRoute, e)} >
                    {/*<Icon style={{ color: 'white', fontSize: this.props.displayData.sizes.fntLarge }} type="left-circle-o" />*/}
                    ICON
                </div>
            )
        }
        return (<span />);

    }

    slideChanged(slide) {
        this.setState({
            selectedImage: slide
        })
    }

    handleOrientation() {
        let blockWidth;
        if (this.props.screen.orientation === "horizontal") {
            blockWidth = this.props.screen.r16_9.half - (this.props.screen.r16_9.p10 * 2);
            blockWidth = 2 * Math.round(blockWidth / 2);
        }
        else {
            blockWidth = this.props.screen.r16_9.half - (this.props.screen.r16_9.p10 * 2);
        }
        var settings = {
            dots: false,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            useCSS: true,
            afterChange: (currentSlide) => {
                this.slideChanged(currentSlide);
            },
        };

        let modules = this.prepareModules(blockWidth);

        let headlineText = {
            textAlign: 'vertical',
            display: 'inline-block',
            color: 'white',
            fontSize: this.props.screen.r16_9.p10 * .6,
            lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
            letterSpacing: 2,
            position: 'absolute',
        }

        // lineHeight: this.props.displayData.sizes.fntLarge*.68, 
        // height: this.props.displayData.sizes.fntLarge*.68, 


        let bodyText = { color: 'white', fontSize: this.props.screen.r16_9.p10 * 0.3 }
        //let backbutton = this.prepareBackButton();");
        let cycleButtons = this.prepareCycleButtons(blockWidth);

        if (this.props.screen.orientation === "horizontal") {
            return (

                <div>
                    <div style={{ position: 'fixed', textAlign: 'left', left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10, top: this.props.screen.r16_9.p10, width: blockWidth }}>
                        <span className="pnormal" style={headlineText}><b>{this.props.story.contents.headline}</b></span><br />
                        <div style={{ height: this.props.screen.r16_9.p10 * .75 }} />
                        <span className="pnormal" style={bodyText}>{this.props.story.contents.story}</span><br />
                    </div>
                    <div style={{ position: 'fixed', textAlign: 'left', left: this.props.screen.r16_9.left + (this.props.screen.r16_9.h10 * 5) + this.props.screen.r16_9.p10, top: this.props.screen.r16_9.p10, width: blockWidth, height: blockWidth }}>
                        <Slider ref={el => this.refDict[0] = el} {...settings}>
                            {modules}
                        </Slider>
                        <div style={{ width: '100%', height: this.props.screen.screenHeight * .045 }} />
                        {/*<div style={{position: 'absolute', left: blockWidth/2, width: blockWidth}}>
                        | debug center
                        </div>*/}
                        {cycleButtons}
                    </div>



                </div>
                /*<div style={{position: 'absolute', width: '100vw', height: '100vh'}}>
                    <div style={{ position: 'absolute', textAlign: 'left', left: '5vw', top: '5vw', width: '40vw' }}>
                        <span className="pnormal" style={headlineText}>{props.story.contents.headline}</span><br />
                        <br />
                        <span className="pnormal" style={bodyText}>{props.story.contents.story}</span><br />
                    </div>
                    <div style={{ position: 'absolute', textAlign: 'right', right: '5vw', top: '5vw', width: blockWidth, height: blockWidth }}>
                        <Slider {...settings}>
                            {modules}
                        </Slider>
                    </div>
                </div>*/
                /*<Col span={24}>
                    <Col span={10}>
                        <span className="pnormal" style={headlineText}>{props.story.contents.headline}</span><br />
                        <span className="pnormal" style={bodyText}>{props.story.contents.story}</span><br />
                        {backbutton}
                    </Col>
                    <Col span={2} />
                    <Col span={12}>
                        <div style={{ width: imageWidth, height: imageWidth }}>
                            <Slider {...settings}>
                                {modules}
                            </Slider>
                        </div>
                    </Col>

                </Col>*/
            )
        }
        else {
            return (
                <div>
                    <div style={{ width: blockWidth, textAlign: 'center' }}>
                        <div style={{ margin: "0 auto", textAlign: 'center', width: blockWidth, height: blockWidth }}>
                            <Slider {...settings}>
                                {modules}
                            </Slider>
                        </div>
                        <br /><br />
                        <span style={headlineText}>{this.props.story.contents.headline}</span><br />
                        <span style={bodyText}>{this.props.story.contents.story}</span><br />
                    </div>
                    {/*{backbutton}*/}
                </div>
            )
        }

    }



    render() {
        // if (this.props.displayData.selectedModuleId === -1 || !this.props.story.id) {          
        //         return (<div />)
        // }
        let content = this.handleOrientation();

        return (
            <div style={{ position: 'absolute' }}>
                <div style={{ zIndex: 10, width: '100vw', height: '100vh' }}>
                    {content}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    let dm, story; 
    if (state.options.id){
        story = _.find(state.content.stories, {id: state.options.id});
    }
    else if (state.options.idleModule || state.options.idleModule===0){
        dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data 
        if (dm);
        story = dm.stories[0];
    }
    else{
        dm = state.content.dm_active[state.active_module]
        story = dm.stories[0];
    }
    
    return {
        screen: state.screen,
        options: state.options,
        story: story
    };
};

export default connect(mapStateToProps, null)(Story);


// WEBPACK FOOTER //
// ./src/Components/Story/Story.js